module.exports = __webpack_public_path__ + "static/img/electric-locomotive_256.241b66a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/electric-locomotive_256.png
// module id = T6y5
// module chunks = 0